<script lang="ts" module>
  import CtaButton from '@/ui/elements/buttons/CTAButton.svelte';
  import BaseCard from '@/ui/elements/card/BaseCard.svelte';
  import CardHeader from '@/ui/elements/card/CardHeader.svelte';
  import { useActiveText, useTeoCore } from '@/utils/teo-context';
</script>

<script lang="ts">
  let teoCore = useTeoCore();
  let activeText = useActiveText();
  let inputValue = $state('');
  let loading = $state(false);

  function updateText(textString: string) {
    // const origEditable = activeText.current.isEditable;
    // activeText.current.isEditable = true;
    // activeText.current.text = data.text;
    // activeText.current.serialized = data.serialized;
    // // activeText.current.configuration = data.configuration;
    // activeText.current.lastEdited = data.lastEdited;
    // activeText.current.analysis = null;
    // // activeText.current.isEditable = false;

    // // TODO: check if config is different first
    // // activeText.current.events.triggerEvent('configChanged', data.configuration);
    // activeText.current.isEditable = origEditable;
    // activeText.current.events.triggerEvent('editable', origEditable);
    // activeText.current.events.triggerEvent('textChangedExternal', undefined);

    // // TODO: check if analysis state is different first
    // activeText.current.events.triggerEvent('analysisStateChanged', undefined);

    activeText.current.updateText(textString);
    activeText.current.events.triggerEvent('analysisStateChanged', undefined);
  }

  $effect(() => {
    return activeText.current.events.addEventListener('gotAnalysis', () => {
      activeText.current.ui.update(
        'view',
        activeText.current.ui.state.previousView || 'performance',
      );
    });
  });
  async function createText() {
    loading = true;
    try {
      const newText = await teoCore.textCreator.getAiSuggestion(inputValue, 'create_text');
      updateText(newText);
    } catch (error) {
      alert(String(error));
    } finally {
      loading = false;
    }
  }
</script>

<BaseCard class="relative">
  <CardHeader cardLabel="Anweisungen"></CardHeader>
  <textarea bind:value={inputValue} class="w-full rounded-md border border-c-divider p-1" rows={10}
  ></textarea>
  <CtaButton
    {loading}
    variant="cta"
    disabled={inputValue.length === 0}
    icon="MagicButton"
    onclick={createText}>Text erstellen</CtaButton
  >
</BaseCard>
